<template>
  <transition name="modal-fade">
    <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div class="bg-white w-full max-w-md rounded-2xl shadow-xl p-6 space-y-5">
        <header class="flex items-center justify-between">
          <div>
            <p class="text-xs uppercase tracking-[0.2em] text-gray-500">Cobro exprés</p>
            <h3 class="text-xl font-bold text-gray-900">Depósito presencial</h3>
          </div>
          <button
            type="button"
            class="text-gray-400 hover:text-gray-600"
            @click="emitirCerrar"
          >
            <span class="text-2xl leading-none">&times;</span>
          </button>
        </header>

        <div class="space-y-3">
          <p class="text-sm text-gray-500">Servicio / referencia</p>
          <p class="text-lg font-semibold text-gray-900">{{ nombreProducto }}</p>
          <p class="text-sm text-gray-500">Cliente: {{ producto.pacienteNombre || "Sin datos" }}</p>
          <div class="rounded-2xl border border-gray-200 px-4 py-3 flex items-center justify-between">
            <span class="text-sm uppercase tracking-[0.3em] text-gray-400">Total</span>
            <span class="text-2xl font-bold text-gray-900">${{ montoFormateado }}</span>
          </div>
        </div>

        <div class="space-y-4">
          <label class="text-sm font-semibold text-gray-700">Método de pago</label>
          <select
            v-model="metodoSeleccionado"
            class="w-full border border-gray-300 rounded-xl px-4 py-3 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 bg-white"
          >
            <option value="efectivo">Efectivo</option>
            <option value="pos">POS tarjeta</option>
            <option value="transferencia">Transferencia</option>
          </select>
          <label class="text-sm font-semibold text-gray-700">Monto recibido</label>
          <input
            type="number"
            min="0"
            step="0.01"
            v-model.number="montoCobrado"
            class="w-full border border-gray-300 rounded-xl px-4 py-3 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 bg-white"
          />
        </div>

        <footer class="flex items-center justify-between">
          <button
            type="button"
            class="px-4 py-2 rounded-xl border border-gray-200 text-gray-700 hover:border-gray-300"
            @click="emitirCerrar"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="px-5 py-3 bg-orange-600 text-white font-semibold rounded-xl shadow-lg hover:bg-orange-700 disabled:opacity-60"
            :disabled="montoCobrado <= 0"
            @click="emitirConfirmar"
          >
            Registrar pago
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DepositCheckout",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    producto: {
      type: Object,
      required: true,
    },
    metodoInicial: {
      type: String,
      default: "efectivo",
    },
  },
  data() {
    return {
      metodoSeleccionado: this.metodoInicial,
      montoCobrado: this.producto?.precio || 0,
    };
  },
  computed: {
    nombreProducto() {
      return (
        this.producto?.nombre ||
        "Depósito presencial" +
          (this.producto?.citaId ? ` (${this.producto.citaId})` : "")
      );
    },
    montoFormateado() {
      return (Number(this.producto?.precio) || 0).toFixed(2);
    },
  },
  watch: {
    producto: {
      handler() {
        this.montoCobrado = Number(this.producto?.precio) || 0;
      },
      immediate: true,
    },
    metodoInicial: {
      handler(nuevo) {
        this.metodoSeleccionado = nuevo;
      },
      immediate: true,
    },
  },
  methods: {
    emitirConfirmar() {
      this.$emit("confirmar", {
        producto: this.producto,
        metodo: this.metodoSeleccionado,
        monto: Number(this.montoCobrado) || 0,
      });
    },
    emitirCerrar() {
      this.$emit("cancelar");
    },
  },
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
